export enum CorporateNavigation {
    HOME = 'home',
    ABOUTUS = 'about',
    CONTACT_FOREVERE_LIVING = 'contact-forever-living'
}
